// Dashboard shared types and utilities

export type TimePeriod = '24h' | '7d' | '30d' | 'all'

// Platform launch date used as earliest possible date for "all" period
const PLATFORM_EPOCH = new Date('2026-01-01T00:00:00Z')

const PERIOD_MS: Record<Exclude<TimePeriod, 'all'>, number> = {
  '24h': 24 * 60 * 60 * 1000,
  '7d': 7 * 24 * 60 * 60 * 1000,
  '30d': 30 * 24 * 60 * 60 * 1000,
}

/** Convert a TimePeriod to milliseconds */
export function periodToMs(period: TimePeriod): number {
  if (period === 'all') return Date.now() - PLATFORM_EPOCH.getTime()
  return PERIOD_MS[period]
}

/** Get the start date for a given period (from now) */
export function periodToDate(period: TimePeriod): Date {
  if (period === 'all') return PLATFORM_EPOCH
  return new Date(Date.now() - PERIOD_MS[period])
}

/** Get start/end dates for the previous equivalent period (for comparison) */
export function previousPeriodDates(period: TimePeriod): { start: Date; end: Date } | null {
  if (period === 'all') return null // no comparison for lifetime view
  const ms = PERIOD_MS[period]
  const end = new Date(Date.now() - ms)
  const start = new Date(end.getTime() - ms)
  return { start, end }
}

/** Human-readable label for a period */
export function formatPeriodLabel(period: TimePeriod): string {
  switch (period) {
    case '24h': return 'last 24 hours'
    case '7d': return 'last 7 days'
    case '30d': return 'last 30 days'
    case 'all': return 'all time'
  }
}
